import "controllers";

import LocationMapComponent from "../components/location_map_component";
window.LocationMapComponent = LocationMapComponent;
